goog.provide("shadow.js.shim.module$src$svg$weather$cloud_svg$default");
shadow.js.shim.module$src$svg$weather$cloud_svg$default = shadow.js.shim.module$src$svg$weather$cloud_svg.default;
